function searchComponent() {
    $('#mobile-search-toggle').on('click', function() {
        $('#search-mobile').fadeIn(400);
    });

    $('#close-search-mobile').on('click', function() {
        $('#search-mobile').fadeOut(400);
    })
}